import { CONTACT } from "@/data/landingData";
import { useLanguage } from "@/context/LanguageContext";
import { trackEvent } from "@/utils/ga4";

const HeroContent = () => {
  const { copy } = useLanguage();

  return (
    <div className="hero-content" data-testid="hero-content">
      <p className="hero-kicker" data-testid="hero-kicker">
        {copy.hero.kicker}
      </p>
      <h1 className="hero-title" data-testid="hero-title">
        {copy.hero.title}
      </h1>
      <p className="hero-subtitle" data-testid="hero-subtitle">
        {copy.hero.subtitle}
      </p>
      <div className="hero-actions" data-testid="hero-actions">
        <a
          className="primary-button"
          href={`${CONTACT.whatsappLink}?text=${encodeURIComponent(copy.hero.whatsappPrefill)}`}
          target="_blank"
          rel="noreferrer"
          data-testid="hero-primary-cta"
          onClick={() =>
            trackEvent("cta_click", { location: "hero", action: "primary", label: copy.hero.primaryCta })
          }
        >
          {copy.hero.primaryCta}
        </a>
        <a
          className="secondary-button"
          href="#solutions"
          data-testid="hero-secondary-cta"
          onClick={() =>
            trackEvent("cta_click", { location: "hero", action: "secondary", label: copy.hero.secondaryCta })
          }
        >
          {copy.hero.secondaryCta}
        </a>
      </div>
      <div className="trust-badges" data-testid="trust-badges">
        {copy.hero.trustBadges.map((badge, index) => (
          <span key={badge} className="trust-badge" data-testid={`trust-badge-${index}`}>
            {badge}
          </span>
        ))}
      </div>
    </div>
  );
};

export default HeroContent;